// src/components/FailedLoginsNotice.jsx
// Уведомление после входа: сколько было неудачных попыток входа с прошлого входа.
// Появляется с анимацией и само скрывается через HIDE_AFTER_MS; пока курсор на нём — не скрывается.
// Если попыток не было, App его не рендерит.

import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { Button } from './ui';

const HIDE_AFTER_MS = 10000;
const LEAVE_ANIMATION_MS = 300; // = длительность animate-notice-out в tailwind.config.js

// attempts — число или строка вида "200+" (когда попыток больше, чем хранится)
export const FailedLoginsNotice = ({ attempts, onClose }) => {
  const { t } = useTranslation();
  const [leaving, setLeaving] = useState(false);
  const [hovered, setHovered] = useState(false);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  // Таймер скрытия; наведение курсора его останавливает, уход курсора — запускает заново
  useEffect(() => {
    if (hovered || leaving) return;
    const timer = setTimeout(() => setLeaving(true), HIDE_AFTER_MS);
    return () => clearTimeout(timer);
  }, [hovered, leaving]);

  // Сначала проигрываем анимацию исчезновения, потом убираем из DOM
  useEffect(() => {
    if (!leaving) return;
    const timer = setTimeout(() => onCloseRef.current(), LEAVE_ANIMATION_MS);
    return () => clearTimeout(timer);
  }, [leaving]);

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50 w-full max-w-md px-4" role="status">
      <div
        className={`${leaving ? 'animate-notice-out' : 'animate-notice-in'} bg-white rounded-xs shadow-2xl px-5 py-4 flex items-center gap-4`}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <div className="w-1 self-stretch rounded-full bg-amber-500 flex-shrink-0" />
        <p className="flex-1 text-sm text-gray-700">
          {/* count — для выбора формы слова (попытка/попытки/попыток), shown — что показываем */}
          {t('App.failed_logins_since_last', { count: parseInt(attempts, 10) || 0, shown: attempts })}
        </p>
        <Button variant="icon" onClick={() => setLeaving(true)} className="text-gray-400 hover:text-gray-900">
          <X size={16} />
        </Button>
      </div>
    </div>
  );
};
